/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useMemo } from 'react';

import { getDummyArray } from '../../../../utils/getDummyArray';
import { createTextPlaceholderStyles } from './TextPlaceholder.styles';

interface TextPlaceholderProps {
  length: number;
  icon: React.ReactElement<any>;
  className?: string;
}

export const TextPlaceholder = memo<TextPlaceholderProps>(props => {
  const { length, icon, className } = props;
  const classes = createTextPlaceholderStyles();

  const dummyArray = useMemo(() => getDummyArray({ length }), [length]);

  return (
    <div className={className}>
      {dummyArray.map(i => (
        <span key={i} className={classes.icon}>
          {icon}
        </span>
      ))}
    </div>
  );
});
